module.exports = __webpack_public_path__ + "static/media/bg_funnil.b957c4c6.svg";